<template>
    <div class="plan-forcast-import">
        <Form ref="form" :model="formData">
            <FormItem label="已有数据是否更新" prop="isUpdate" :rules="required">
                <RadioGroup v-model="formData.isUpdate">
                    <Radio label="0">不更新</Radio>
                    <Radio class="margin-left-20" label="1">更新</Radio>
                </RadioGroup>
            </FormItem>
        </Form>
        <compMutiUpload v-bind="getFileProps" @on-success="handleSuccess" @on-cancel="$emit('on-close')"></compMutiUpload>
    </div>
</template>

<script>
export default {
    data () {
        return {
            formData: {
                isUpdate: "1"
            },
            required: [{
                required: true,
                message: '此项必填'
            }]
        }
    },
    computed: {
        getFileProps () {
            return {
                action: process.env.VUE_APP_APIURL_BI + '/api/v1/DemandForecast/importByWeek',
				name: "excelFile",
                multiple: false,
                beforeUpload: (dataList) => {
                    if (!this.formData.isUpdate) {
                        this.$VMessage.error('请填写是否更新数据');
                        return false;
                    }
                    return true;
                },
                download: () => {
                    this.handleWebfs(process.env.VUE_APP_APIURL_BI + '/api/v1/DemandForecast/downExcelByWeek', {}, 'download');
                },
				data: {
                    isUpdate: this.formData.isUpdate,
                },
                formatter (res) {
                    this.$VMessage.success(res.message);
                }
            }
        }
    },
    methods: {
        handleSuccess (res) {
            this.$emit('on-update');
            this.$emit('on-close');
        }
    }
}
</script>

<style>

</style>